import React from 'react'
import './Contact.scss'

const Contact = () => {
  return (
    <div>Contact</div>
  )
}

export default Contact